module.exports = __webpack_public_path__ + "static/media/warning.20597638.svg";